









































import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
// eslint-disable-next-line no-unused-vars
import { PageMode } from '@/main/utils/pageMode';
// eslint-disable-next-line no-unused-vars
import { Row } from '@/main/utils/table';
import _ from 'lodash';

import { NAME, DOKLAD_CIS_RADA_TYP, DOKLADCR_ID_KEY } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			DOKLAD_CIS_RADA_TYP,
			extraButtonsOperation: 0,
			platbaPzn: null as number | null,
			dokladDruhNahr: null as number | null,
		};
	},
	computed: {
		tableModelCmp() {
			if (this.table && this.table.columns.length) {
				this.table.columns.filter(x => x.columnName === DOKLADCR_ID_KEY).map(x => { x.isVisible = false; return { ...x }; });
			}
			return { table: this.table, sideBarLoading: this.sideBarLoading };
		},
		rowsOnCurrentPage(): Row[] {
			return (this.$refs.table as Vue & { rowsOnCurrentPage: Row[] })?.rowsOnCurrentPage ?? [];
		},
		rows(): Row[] {
			return this.table.rows;
		},
		isInsertDicliDisabled(): boolean {
			return _.isNil(this.platbaPzn);
		},
	},
	watch: {
		ProvozovnaId(val) {
			if (_.isNil(val)) return;
			this.DokladSk = this.dropdownList.ProvozovnaId.find((item) => item.Value === val)?.DokladSk ?? null;
		},
		rows() {
			const rows = (this.$refs.table as Vue & { rowsOnCurrentPage: Row[] })?.rowsOnCurrentPage ?? [];
			this.extraButtonsOperation = rows.reduce((accumulator, row: Row) => {
				// eslint-disable-next-line no-bitwise, no-param-reassign
				accumulator |= row.cells[this.cellNames.DOKLADCR_STATUS] === DOKLAD_CIS_RADA_TYP.Dilci ? 1 : 0;
				// eslint-disable-next-line no-bitwise, no-param-reassign
				accumulator |= row.cells[this.cellNames.DOKLADCR_STATUS] === DOKLAD_CIS_RADA_TYP.Slucena ? 2 : 0;
				return accumulator;
			}, 0) + 1;
		},
	},
	methods: {
		rowClickHandle({ data, mode }: { data: Record<string, any>; mode: PageMode }) {
			openEdit(NAME, mode, { id: data.DOKLADCR_ID });
		},
		viewDocumentConfig({ data, mode }: { data: Record<string, any>; mode: PageMode }) {
            openEdit(NAME, PageMode.VIEW,  { id: data.DOKLADCR_ID } );
        },
		async insertDilciCR(row: Row) {
			await apiProvider.insertDilciCR({
				DokladSk: row.cells[this.cellNames.DOKLAD_SK],
				DokladDruh: row.cells[this.cellNames.DOKLAD_DRUH],
				PlatbaPzn: this.platbaPzn,
			});
			this.tableData();
		},
		async deleteDilciCR(row: Row) {
			await apiProvider.deleteDilciCR({
				DokladSk: row.cells[this.cellNames.DOKLAD_SK],
				DokladDruh: row.cells[this.cellNames.DOKLAD_DRUH],
				PlatbaPzn: row.cells[this.cellNames.PLATBA_PZN],
			});
			this.tableData();
		},
		async insertNahradniCR(row: Row) {
			await apiProvider.insertNahradniCR({
				DokladDruh: row.cells[this.cellNames.DOKLAD_DRUH],
				DokladDruhNahr: this.dokladDruhNahr,
			});
			this.tableData();
		},
		async deleteNahradniCR(row: Row) {
			await apiProvider.deleteNahradniCR({
				DokladDruh: row.cells[this.cellNames.DOKLAD_DRUH],
			});
			this.tableData();
		},
	},
});
